import React from 'react'
import './home.css'

import HomeNew from '../homenew/HomeNew';
import { useParams } from "react-router-dom"
import { useEffect, useRef} from "react";

import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import DialogBoughtCredits from './DialogBoughtCredits';
//import DialogTestBought from '../aitest/DialogTestBought';

export const Home = () => {

const hasExecuted = useRef(false);

  const { token } = useParams()

 

const {
  setShowDialogBoughtCredits,
 
} = React.useContext(StatusContext);

const {
  setShowTestBought,
 
} = React.useContext(AITestContext);


  useEffect(() => {
    console.log("useEffect: home:", {token})
 
    if (token && token.length < 6)
      {
        console.log("useEffect: home: invalid token")
        return
      }
  
 
    if (hasExecuted.current) 
      {
     
        return; // Prevent execution if already executed
      }
    
    const verifyToken = () => {
      console.log("Toeken:", token)

      if (!token || token === 'logout')
      {
        return
      }

      if ( token === 'CreditsPurchaseSuccess' )
      {
        setShowDialogBoughtCredits(true)
        return
      }

      /*
      if ( token === 'MyTestPurchaseSuccess' )
        {
          setShowTestBought(true)
          return
        }
        */

    }

  verifyToken()
 
  hasExecuted.current = true; // Mark as executed
  

  }, [token,setShowDialogBoughtCredits, setShowTestBought])



  
  return (
    
    <div className="homeContainer">
     
       <HomeNew/>
     
      <DialogBoughtCredits />
      {/*<DialogTestBought />*/}
   
   </div>
  )
}

export default Home